/* eslint-disable prettier/prettier */
/* eslint-disable no-empty */
import {
  HIDE_LOADER,
  SHOW_LOADER,
  SET_SERVER_TYPE,
  UPDATE_FCM_TOKEN,
  SET_BRANCH_DATA,
  SET_BANNER_LIST,
  SET_FACTS_DATA,
  SET_SERVER_DOWN,
  UPDATE_SHARE_CONTEST_STATUS,
  SET_POPUP_DATA,
  SET_POPUP_LAST_SHOW_TIME,
  RESET_BRANCH_DATA,
  SET_CURRENT_LOCATION,
  SET_CURRENT_LOCATION_STATE,
  SET_NET_INFO_DATA,
  SET_LAST_BUILD_CHECK_TIME,
  SET_MOBILE_LOCATION,
  SET_APP_LANGUAGE,
  SHOW_FEEDBACK_MODAL,
  SET_ACTIVE_TAB
} from '../actions/app-actions-types';
import { SET_BANNERS } from '../actions/more-actions-types';

const initialState = {
  loading: false,
  banners: [],
  serverType: 'staging',
  fcmToken: '',
  baseUrlsObj: {},
  branchData: {},
  bannerList: [],
  popupData: {},
  language: 'en',
  bannerPopupLastShowingTime: 0,
  sportsFactsData: {
    lastCallingFactAPITime: 0,
    factsList: []
  },
  isServerDown: false,
  shareContestStatus: {
    isJoined: false,
    isLanded: false
  },
  currentLocation: {},
  currentMobileLocation: {},
  currentLocationState: '',
  netInfo: {},
  lastBuildCheckTime: 0,
  showFeedback: true,
  activeSidebarTab: 'Home',
  activeContestFilter: ''
};

export default function app(state = initialState, action: any) {
  switch (action.type) {
    case HIDE_LOADER:
      return {
        ...state,
        loading: false
      };

    case SHOW_LOADER:
      return {
        ...state,
        loading: true
      };
    case SET_BANNERS:
      return {
        ...state,
        banners: action.payload
      };
    case SET_SERVER_TYPE:
      return {
        ...state,
        serverType: action.payload
      };
    case UPDATE_FCM_TOKEN:
      return {
        ...state,
        fcmToken: action.payload
      };

    case SET_BRANCH_DATA: {
      let branchData: any = { ...state.branchData };
      if (action.payload && action.payload['installParams']) {
        branchData['installParams'] = action.payload['installParams'];
      }
      if (action.payload && action.payload['currentParams']) {
        branchData['currentParams'] = action.payload['currentParams'];
      }
      return {
        ...state,
        branchData
      };
    }

    //reset branch data for contest
    case RESET_BRANCH_DATA: {
      let branchData: any = { ...state.branchData };
      try {
        if (branchData['currentParams']) {
          const { $custom_meta_tags: currentParamsMeta = '' } = branchData['currentParams'];
          const custom_meta_tags = JSON.parse(currentParamsMeta);
          branchData['currentParams'] = {
            ...branchData['currentParams'],
            $custom_meta_tags: JSON.stringify({
              ...custom_meta_tags,
              contestId: '',
              title: '',
              description: '',
              matchId: '',
              type: ''
            })
          };
        }
      } catch (err) {}
      return {
        ...state,
        branchData
      };
    }

    case SET_BANNER_LIST:
      return {
        ...state,
        bannerList: action.payload
      };
    case SET_FACTS_DATA:
      return {
        ...state,
        sportsFactsData: action.payload
      };
    case SET_SERVER_DOWN:
      return {
        ...state,
        isServerDown: action.payload
      };
    case UPDATE_SHARE_CONTEST_STATUS:
      return {
        ...state,
        shareContestStatus: action.payload
      };
    case SET_POPUP_DATA:
      return {
        ...state,
        popupData: action.payload
      };
    case SET_POPUP_LAST_SHOW_TIME:
      return {
        ...state,
        bannerPopupLastShowingTime: action.payload
      };
    case SET_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.payload
      };
    case SET_CURRENT_LOCATION_STATE:
      return {
        ...state,
        currentLocationState: action.payload
      };
    case SET_NET_INFO_DATA:
      return {
        ...state,
        netInfo: action.payload
      };
    case SET_LAST_BUILD_CHECK_TIME:
      return {
        ...state,
        lastBuildCheckTime: action.payload
      };
    case SET_MOBILE_LOCATION:
      return {
        ...state,
        currentMobileLocation: action.payload
      };
    case SET_APP_LANGUAGE:
      return {
        ...state,
        language: action.payload
      };
    case SHOW_FEEDBACK_MODAL:
      return {
        ...state,
        showFeedback: action.payload
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeSidebarTab: action.payload
      };

    default:
      return state;
  }
}
